import {
  createColumnConfig,
  StandardTableConfigWithNoGroups,
} from "@stenajs-webui/grid";
import { cssColor } from "@stenajs-webui/theme";
import { Text } from "@stenajs-webui/core";
import { StatisticsByAgreedVolumeListItem } from "@/gql/graphql";

export type StatisticsAgreedVolumeDataListColumns =
  | "customer"
  | "route"
  | "agreedVolume"
  | "shippedVolume"
  | "performance";

export const statisticsByAgreedVolumeTableConfig =
  (): StandardTableConfigWithNoGroups<
    StatisticsByAgreedVolumeListItem,
    StatisticsAgreedVolumeDataListColumns
  > => ({
    keyResolver: (item) => item.statCustomerIndex + "-" + item.routePairCode,
    stickyHeader: true,
    rowIndent: 2,
    initialSortOrder: "customer",
    columns: {
      customer: createColumnConfig(
        (item) => `${item.statCustomerIndex} (${item.statNumber})`,
        {
          columnLabel: "Customer",
        }
      ),
      route: createColumnConfig((item) => item.routePairCode, {
        columnLabel: "Route",
      }),
      agreedVolume: createColumnConfig((item) => item.agreedVolume, {
        columnLabel: "Agreed Volume",
      }),
      shippedVolume: createColumnConfig((item) => item.shippedVolume, {
        columnLabel: "Shipped Volume",
      }),
      performance: createColumnConfig((item) => item.performanceInPercent, {
        columnLabel: "Performance",
        renderCell: ({ item }) => (
          <Text
            color={
              item.performanceInPercent < 95
                ? cssColor("--lhds-color-red-600")
                : cssColor("--lhds-color-ui-900")
            }
          >
            {item.performanceInPercent} %
          </Text>
        ),
      }),
    },
    columnOrder: [
      "customer",
      "route",
      "agreedVolume",
      "shippedVolume",
      "performance",
    ],
  });
